import React, { useState, useId } from "react";
import InPlaceError from "components/in-place-error/InPlaceError";
import "./select.scss";


interface IOptions {
  options: string[];
  placeholder?: string;
  errorMessage?: string;
  onChange?: (e: string) => void;
  label?: string;
  className?: string;
  initialValue?: string;
}
export const Select = React.forwardRef(
  (
    {
      options,
      placeholder = "Select an option",
      errorMessage,
      className,
      onChange,
      label,
      initialValue = "",
    }: IOptions,
    _ref
  ) => {
    const [selectedItem, setSelectedItem] = useState(initialValue);
    const showError = !!errorMessage;
    const selectId = useId();

    return (
      <div className={`dropdown-container ${className ?? ""}`}>
        {label && (
          <div className="input-label__wrapper">
            <label htmlFor={selectId} className="input-label">
              {label}
            </label>
          </div>
        )}
        <div className="dropdown__wrapper">
          <select
            id={selectId}
            className={showError ? "dropdown dropdown--error" : "dropdown"}
            value={selectedItem}
            onChange={(e) => {
              onChange?.(e.target.value);
              setSelectedItem(e.target.value);
            }}
            aria-label={label ?? "Select an option"}
          >
            <option value="" disabled>{placeholder}</option>
            {options.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>
          {showError && <InPlaceError errorPhrase={errorMessage} />}
        </div>
      </div>
    );
  }
);

Select.displayName = "Select";
